// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"353":"contact","594":"about","671":"services","962":"home"}[chunkId] || chunkId) + "." + {"348":"54dc50ed","353":"e1272177","594":"8955300d","671":"f4c1899f","930":"f3278538","962":"af033183"}[chunkId] + ".css";
};